import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledFileUploaderContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isDragging" && prop !== "sx",
})<{ isDragging: boolean; sx: any }>(({ isDragging, sx }) => ({
  cursor: "pointer",
  border: `1px ${isDragging ? "#0D47A1" : "#1A73E8"} dashed`,
  backgroundColor: isDragging ? "#E3F2FD" : "transparent",
  ...sx,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  padding: "20px",
  textAlign: "center",
}));

export default StyledFileUploaderContainer;
